import React from 'react';
import './Industries.css';

const industries = [
  { icon: '🏦', title: 'Banking' },
  { icon: '🛒', title: 'Consumer Goods' },
  { icon: '💬', title: 'Communication & Media' },
  { icon: '🚛', title: 'Freight Fleet Management' },
  { icon: '🏥', title: 'Healthcare' },
  { icon: '☂️', title: 'Insurance' },
  { icon: '💰', title: 'Fintech' },
  { icon: '🏠', title: 'Real Estate' },
  { icon: '💾', title: 'Software' },
  { icon: '✈️', title: 'Travel & Hospitality' },
];

const Industries = () => {
  return (
    <section className="snow-industries" id="industries">
      <div className="snow-industries-inner">
        <div className="snow-section-header">
          <span className="snow-section-label">❆ Industries We Serve</span>
          <h2 className="snow-section-title">
            Top-Rated Software Technology Company Serving All Industries
          </h2>
          <p className="snow-section-subtitle">
            We have years of experience catering to custom software development
            needs of several business verticals.
          </p>
        </div>

        <div className="snow-industries-grid">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="snow-industry-item"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="snow-industry-icon">
                <span>{industry.icon}</span>
              </div>
              <span className="snow-industry-title">{industry.title}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
